<template>
  <div class="dashboard-page-cont product-manage">
    <div class="product-manage-head">
      <span class="model-title">未读消息</span>
      <a
        class="model-more"
        :class="{ 'model-more-none': !unReadNum }"
        target="_blank"
        :href="onlineUrl + '/supplier/message/unread-list/1'"
        >{{ this.unReadNum }}条消息待查看 <i class="el-icon-arrow-right"></i
      ></a>
    </div>
    <div class="unread-message-content">
      <div
        v-for="(item, index) in unReadList"
        :key="index"
        @click="handlerClick(item)"
      >
        <div class="unread-message-item">
          <div class="f-r-s-c">
            <i class="icon-Click iconfont"></i>
            <p class="desc">
              {{ item.title }}
            </p>
          </div>
          <p class="time">{{ moment(item.createTime).format('YYYY-MM-DD') }}</p>
        </div>
        <p
          class="mock-button mock-button-default"
          :class="{
            'mock-button2': item.type == 1,
            'mock-button1': item.type == 2,
            'mock-button3': item.type == 4,
          }"
        >
          <i class="person-icon" v-if="item.type == 1"></i>
          <span v-if="item.type == 1">采购消息</span>
          <span v-else>{{ messageType[item.type] }}</span>
          
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { onlineUrl } from '@/utils/config'
import { getUnReadMsgNumApi } from '@/utils/api/dashboard'
import { getDictByTypeNew } from '@/utils/api/common.js'
import moment from 'moment'
export default {
  name: 'unread-message',
  props: [],
  data() {
    return {
      onlineUrl,
      unReadList: [],
      messageType: {
      },
    }
  },
  props: {
    unReadNum: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapState(['userInfo']),
  },
  methods: {
    moment,
    getUnReadMessageList() {
      getUnReadMsgNumApi({ userId: this.userInfo.userId }).then((res) => {
        if (res.rspResult.bizCode == 200) {
          this.unReadList = res.rspListData.list
        }
      })
    },
    handlerClick(item) {
      console.log(item, 'item')
      // https://qa-online.haizol.com/supplier/message/detail/54608
      window.open(this.onlineUrl + '/supplier/message/detail/' + item.id)
    },
    async getMessageType() {
      try {
        const res = await getDictByTypeNew('messagetype')
        if (res.rspResult.bizCode === 200) {
          this.messageType = (res.rspListData.list || []).reduce((pre,cur)=>{
            pre[cur.codeValue] = cur.cn
            return pre
          },{})
        }
      } catch (err) {
        console.error('❌ ~ file: index.vue:381 ~ initData ~ err:', err)
      }
    },
  },
  mounted() {
    this.getMessageType()
  },
  watch: {
    userInfo: {
      handler(val) {
        if (val) {
          this.getUnReadMessageList()
        }
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.product-manage {
  background-color: #fff;
  padding: 20px;
  font-family: SourceHanSansCN-Regular;
  &-head {
    display: flex;
    .model-more {
      margin-left: auto;
      height: 14px;
      line-height: 14px;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #16181a;
      letter-spacing: 0;
      position: relative;
    }
    .model-more.model-more-none::after {
      width: 0;
      height: 0;
    }
    .model-more::after {
      content: '';
      position: absolute;
      top: -3px;
      right: 11px;
      width: 5px;
      height: 5px;
      background: #ff081f;
      border-radius: 50%;
    }
    .model-title {
      color: #16181a;
      font-family: SourceHanSansCN-Bold;
      font-size: 14px;
      line-height: 14px;
      margin-bottom: 17px;
    }
  }
  .unread-message-content {
    display: flex;
    flex-direction: column;
    gap: 11px;
    .unread-message-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      font-family: SourceHanSansCN-Medium;
      font-size: 14px;
      line-height: 22px;
      .time {
        flex-shrink: 0;
        color: #98a3b7;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        font-family: SourceHanSansCN-Regular;
      }
      .desc {
        color: #066eb7;
        font-family: SourceHanSansCN-Bold;
        margin-left: 8px;
      }
    }
    .mock-button{
      display: inline-flex;
      padding: 3px 6px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 2px;
    }
    .mock-button-default {
      border: 1px solid #004de629;
      background: #e9f0ff;
      color: #004de6;
      font-size: 12px;
      font-weight: 400;
      line-height: 14px;
      margin-left: 24px;
    }
    .mock-button1 {
      border: 1px solid #6f00e629;
      background: #eee9ff;
      color: #6f00e6;
      font-size: 12px;
      font-weight: 400;
      line-height: 14px;
      margin-left: 24px;
    }
    .mock-button2 {
      gap: 0px;
      background: #fdecda;
      color: #a44c00;
      font-size: 12px;
      font-weight: 400;
      line-height: 14px;
      margin-left: 24px;
      border: none;
    }
    .mock-button3 {
      gap: 0px;
      border: 1px solid #ff000029;
      background: #FFF6F6;
      color: #ff0000;
      font-size: 12px;
      font-weight: 400;
      line-height: 14px;
      margin-left: 24px;
      border: none;
    }
    .person-icon {
      width: 14px;
      height: 14px;
      background: url('../../assets/image/person.png') no-repeat center center;
      background-size: cover;
    }
  }
}
.f-r-s-c {
  display: flex;
  align-items: center;
  color: #066eb7;
}
</style>
